module.exports = __webpack_public_path__ + "static/media/Neo-Sans-Pro-Bold.65482afb.ttf";